import purify from 'dompurify'

function getPurify() {
  if (purify && typeof purify.sanitize === 'function') {
    return purify
  }

  if (typeof window !== 'undefined' && typeof purify === 'function') {
    return purify(window)
  }

  return null
}

function applySafeHtml(el, value, modifiers = {}) {
  const DOMPurify = getPurify()
  const html = value == null ? '' : String(value)

  el.innerHTML = DOMPurify
    ? DOMPurify.sanitize(html, { USE_PROFILES: { html: true } })
    : ''

  // The question must stay open when a participant follows its reference links.
  if (modifiers.newtab) {
    el.querySelectorAll('a[href]').forEach((link) => {
      link.setAttribute('target', '_blank')
      link.setAttribute('rel', 'noopener noreferrer')
    })
  }
}

export default {
  bind(el, binding) {
    applySafeHtml(el, binding.value, binding.modifiers)
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      applySafeHtml(el, binding.value, binding.modifiers)
    }
  },
}
